"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MeasureTest_1 = __importDefault(require("./MeasureTest"));
var Logger_1 = __importDefault(require("../Logger"));
var Connection_1 = require("../Connections/Connection");
function calculateLatency(samples) {
    if (samples.length < 5) {
        return null; // Too few samples
    }
    // Sort samples (ascending)
    var sortedSamples = __spreadArray([], samples, true).sort(function (a, b) { return a - b; });
    // Keep the best 60% (matching C++ implementation)
    var bestSamplesCount = Math.floor(sortedSamples.length * 3 / 5);
    var bestSamples = sortedSamples.slice(0, bestSamplesCount);
    // Calculate average
    var latencySum = bestSamples.reduce(function (sum, sample) { return sum + sample; }, 0);
    // Return the average latency
    return latencySum / bestSamples.length;
}
var LatencyTest = /** @class */ (function (_super) {
    __extends(LatencyTest, _super);
    function LatencyTest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.samples = [];
        _this.maxSamples = 12;
        _this.name = 'latency';
        _this.tick = function () {
            // No need to adjust any values for latency test
        };
        return _this;
    }
    LatencyTest.prototype.onStart = function () {
        _super.prototype.onStart.call(this);
        this.startTime = (new Date()).getTime();
        this.createConnections('websocket');
    };
    LatencyTest.prototype.handleOpen = function (id) {
        this.connections[id].ping('start');
    };
    LatencyTest.prototype.handleMessage = function (id, e) {
        var time = this.passedTime;
        if (typeof e.data === 'string') {
            var message = e.data.split(' ');
            if (message[0] !== 'challenge') {
                return;
            }
            if (message.length === 3) {
                this.samples.push(+message[1]);
                var nextMessage = message[2];
                message[1] = nextMessage;
            }
            if (this.samples.length < this.maxSamples) {
                this.connections[id].ping(message[1]);
                if (time >= 3000) {
                    this.maxSamples = 20;
                    this.setNoConnections(2);
                }
            }
            else {
                this.done(calculateLatency(this.samples) || -1);
            }
        }
        else {
            // Got bin
        }
    };
    LatencyTest.prototype.done = function (result) {
        var _this = this;
        var endSocket = this.pool.reserveByType('websocket');
        var endTimer;
        this.connections[endSocket.id] = endSocket;
        if (endSocket && endSocket.type === 'websocket') {
            Logger_1.default.log("Connection ".concat(endSocket.id, " got the honor to end the latency test."));
            endSocket.on(Connection_1.ConnectionEvents.MESSAGE, function (id, e) {
                var data = e.data;
                var _a = data.split(' '), eventName = _a[0], value = _a[1];
                if (eventName === 'latency_result') {
                    Logger_1.default.log("Got a latency result from the server. Client: ".concat(result, ", Server: ").concat(value));
                    window.clearTimeout(endTimer);
                    _super.prototype.done.call(_this, Number(value));
                }
            });
            endSocket.on(Connection_1.ConnectionEvents.OPEN, function () { return endSocket.ping('end'); });
            endSocket.ready();
            endTimer = window.setTimeout(function () {
                _super.prototype.done.call(_this, result);
            }, 10000);
        }
        else {
            _super.prototype.done.call(this, result);
        }
    };
    return LatencyTest;
}(MeasureTest_1.default));
exports.default = LatencyTest;
//# sourceMappingURL=LatencyTest.js.map